module.exports = __webpack_public_path__ + "img/2_top1_2.69ba2365.png";